import { getAllocationsFilter } from '~/services/localStorage/filters';
import { IClientAllocationStore } from './types';

const defaultPagination = {
  total: 0,
  pageNumber: 1,
  pageSize: 25,
};

const defaultFilters = getAllocationsFilter() || {
  sorting: 1,
  dateRange: [],
};

const initStore: IClientAllocationStore = {
  current: null,
  list: [],
  standardList: [],
  crisisList: [],
  locationGroups: [],
  relatedClients: [],
  pagination: defaultPagination,
  standardPagination: defaultPagination,
  crisisPagination: defaultPagination,
  filters: defaultFilters,
  standardFilters: defaultFilters,
  crisisFilters: defaultFilters,
  dateAvailability: null,
  teamMemberDateValidation: null,
};

export default initStore;
